import React from 'react'
import { Link } from '@mui/material'
import { splitByUrls } from './splitByUrls'

/**
 * @content : テキスト内容
 */
interface Props {
  content: string
}

/**
 * テキスト中のURLを検出し、タップで外部ブラウザに遷移可能なリンクとして表示するコンポーネント。
 *
 * @description
 * - URLが含まれない場合は通常の Text として描画する。
 * - URL部分は通常のアンカー相当（MUI Link + href + target="_blank"）として新しいタブ/ウィンドウで開く。
 */
export default function LinkifyText({ content }: Props) {
  const parts = splitByUrls(content)

  return (
    <>
      {parts.map((part, i) =>
        part.type === 'url' ? (
          <Link key={i} href={part.value} target="_blank">
            {part.value}
          </Link>
        ) : (
          <React.Fragment key={i}>{part.value}</React.Fragment>
        ),
      )}
    </>
  )
}
